import { SortDirection } from 'types/enums'

import { setDirection } from './methods'

export const changeSortDirection = (currSortDirection: SortDirection) => {
    const newDirection =
        currSortDirection === SortDirection.ASCENDING
            ? SortDirection.DESCENDING
            : SortDirection.ASCENDING

    setDirection(newDirection)
}
